import { Box } from '@mui/material';
import { memo } from 'react';
import { ReactComponent as ChatIcon } from '../../assets/icons/chatbutton.svg';

export const ChatEnterButton = memo(({ onClick, sx, messagesAmont = '' }) => (
    <Box
        onClick={onClick}
        sx={(theme) => ({
            position: 'fixed',
            width: '64px',
            height: '64px',
            p: 2,
            bgcolor: 'button.main',
            borderRadius: theme.palette.button.borderRadius + 'px !important',
            cursor: 'pointer',
            ...sx,
        })}
    >
        <Box
            component={ChatIcon}
            sx={(theme) => ({
                '& path': {
                    fill: theme.palette.button.icon,
                },
            })}
        >
            {messagesAmont}
        </Box>
    </Box>
));
